import { render, staticRenderFns } from "./PatologieComponent.vue?vue&type=template&id=d401eaf0&"
import script from "./PatologieComponent.vue?vue&type=script&lang=js&"
export * from "./PatologieComponent.vue?vue&type=script&lang=js&"
import style0 from "./PatologieComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports